import { memo } from 'react'

import { Id, RowType } from '../types'

type Props<TCol extends { id: Id }> = RowType<TCol> & {
    cols: TCol[]
    gridTemplateColumns: string
}

const RowsComponent = <TCol extends { id: Id }>({ cols, gridTemplateColumns, rowHeader, cellClassName, cellRender }: Props<TCol>) => (
    <div className="grid border-t first:border-t-0" style={{ gridTemplateColumns }}>
        {rowHeader && <div className="sticky left-0 z-elevated overflow-hidden truncate border-r-2 bg-surface-base">{rowHeader()}</div>}

        {cols.map(col => (
            <div key={col.id} className={`overflow-hidden border-r bg-surface-base last:border-r-0 [&_.outline]:last:rounded-tr-[3px] ${cellClassName?.(col)}`}>
                {cellRender?.(col)}
            </div>
        ))}
    </div>
)

export const Rows = memo(RowsComponent) as typeof RowsComponent
